module.exports = __webpack_public_path__ + "img/logo.919c4d0e.png";